export class ModalConfig {
	data?: any;
}
